import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:managePointInaccuraciesList
 * @description
 * # manageActivityTypeList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'managePointInaccuraciesList',
    ($ngRedux, $rootScope, $scope, $location, $route, $timeout, $http, ENV) => {
      if (!$scope.isSuperUser) {
        $location.path('/');
      }

      $scope.init = () => {
        $rootScope.previousRoute = $rootScope.routes.points;
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.table = {
        name: 'Point History Inaccuracies',
        options: {
          endpoint: '/2.0/points/inaccuracy/',
          endpoint_data_key: 'points-inaccuracies',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'standard',
          scale_up: false,
          search_key: 'Point Inaccuracies',
          search_required: false,
        },
        actions: [],
        columns: [
          {
            name: 'Created',
            options: {
              content:
                '{{ record.created }}',
              class: '',
            },
          },
          {
            name: 'User',
            options: {
              content:
                '<a ng-if="record.user.first_name || record.user.last_name" href="#" ng-href="/admin/users/manage-users/{{ record.user.id }}">' +
                '{{ record.user.first_name }} {{ record.user.last_name }}' +
                '</a>' +
                '<br ng-if="record.user.contact_information.email && (record.user.first_name || record.user.last_name)" />' +
                '<a ng-class="{\'small email\': (record.user.first_name || record.user.last_name)}" ng-if="record.user.contact_information.email" href="#" ng-href="/admin/users/manage-users/{{ record.user.id }}">' +
                '{{ record.user.contact_information.email }}' +
                '</a>',
              class: '',
            },
          },
          {
            name: 'Error',
            options: {
              content: '<span style="white-space: pre-line">{{ record.error | toHtml }}</span>',
              class: '',
            },
          },
          {
            name: 'Redeemable Points Values Comparison',
            options: {
              content: '<strong class="bold">Calculation:</strong> {{ record.formula_available_balance }}' +
              '<br /><strong class="bold">Database:</strong> {{ record.atlas_available_balance }}' +
              '<br /><strong class="bold">Difference:</strong> {{ record.atlas_available_balance - record.formula_available_balance }}',
              class: '',
            },
          },
          {
            name: 'Total Points Values Comparison',
            options: {
              content: '<strong class="bold">Calculation:</strong>{{ record.formula_total_points }}' +
              '<br /><strong class="bold">Database:</strong> {{ record.atlas_total_points }}' +
              '<br /><strong class="bold">Difference:</strong> {{ record.atlas_total_points - record.formula_total_points }}',
              class: '',
            },
          },
        ],
        filters: [
          {
            name: 'Timeframe',
            type: 'single_choice',
            options: {
              choices: {
                'Last 24 Hours': { type: 'standard', state: true, value: 'day', order: 0 },
                'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
                'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
                All: { type: 'standard', state: false, value: 'all', order: 3 },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: true,
                  order: 4,
                  error: false,
                },
              },
              class: 'timeframe-filter above-divider',
              query_string_parameter: 'timeframe',
            },
          },
        ],
        sort_options: {
          created: {
            state: true,
            value: '-1',
            title: 'Created',
            order: 0,
          },
          user_id: {
            state: false,
            value: '-1',
            title: 'User ID',
            order: 1,
          },
          max_points_history__created: {
            state: false,
            value: '1',
            title: 'Max Points History Record',
            order: 2,
          },
        },
      };

      $scope.init();

      $scope.$on('$destroy', $scope.unsubscribe);
    },
  );
